import { createFrontendPlugin } from '@backstage/frontend-plugin-api';

import { tessaLicenseTypePickerExtension } from './tessa-license-types-fields';
import { tessaOboAssertionDecorator } from './tessa-obo-assertion-decorator';
import { tessaUserLicensePickerExtension } from './tessa-user-licenses-fields';
import {
  workspaceKeyFieldExtension,
  workspaceNameFieldExtension,
} from './tessa-workspace-fields';

export { TessaLicenseTypePicker } from './tessa-license-types-fields';
export { TessaUserLicensePicker } from './tessa-user-licenses-fields';
export {
  TessaWorkspaceKeyField,
  TessaWorkspaceNameField,
} from './tessa-workspace-fields';

export default createFrontendPlugin({
  extensions: [
    tessaLicenseTypePickerExtension,
    tessaOboAssertionDecorator,
    tessaUserLicensePickerExtension,
    workspaceKeyFieldExtension,
    workspaceNameFieldExtension,
  ],
  pluginId: 'ns-tessa-scaffolder-field',
});
